module.exports = __webpack_public_path__ + "static/media/kocka2POMOZIBA.54519b32.png";